// Zone.js patches every `on<event>` property it finds on `window`,
// including `onunload` — once patched, assigning that property routes
// through zone.js's own wrapped addEventListener call. Chrome deprecates
// 'unload' listeners because they block bfcache eligibility. This flag
// must be evaluated before zone.js loads — hence its own file, listed
// ahead of zone.js in project.json's polyfills array.
// https://github.com/angular/angular/blob/main/packages/zone.js/README.md
interface ZoneGlobal {
  __Zone_ignore_on_properties?: Array<{ target: unknown; ignoreProperties: string[] }>;
}

(window as unknown as ZoneGlobal).__Zone_ignore_on_properties = [{ target: window, ignoreProperties: ['unload'] }];
